import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import FlightBanner from '../Components/Flight/FlightBanner'
import FlightBooking from '../Components/Flight/FlightBooking'
import FlightOffers from '../Components/Flight/FlightOffers'
import FlightDestinations from '../Components/Flight/FlightDestinations'
import FlightServices from '../Components/Flight/FlightServices'
import FooterOne from '../Components/Footer/FooterOne'
import ScrollToTop from '../Components/ScrollToTop'

function HomeFive() {
    return (
        <div>
            <HeaderOne />
            <FlightBanner />
            <FlightBooking />
            <FlightOffers />
            <FlightDestinations />
            <FlightServices />
            <FooterOne />
            <ScrollToTop />
        </div>
    )
}

export default HomeFive
